export const DEFAULT_CHANNEL = 'email';

export const TAG_NAME = 'uam/security/successfulLoginNotification';

export const DEFAULT_FORM_DATA = {
    notifications: false,
    channel: DEFAULT_CHANNEL
};
